// extracted by mini-css-extract-plugin
export default {"root":"SuccessMessage_root__TKcPX"};